<template>
  <div class="container-fluid">

    <div class="row py-3">
      <div class="col-md-12">
        <h1 class="text-center">Clients</h1>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-md-12 d-flex">
        <b-button variant="success" to="/clients/create">Create client</b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <clients-table :clients="clients"></clients-table>

        <b-pagination v-if="total > itemsPerPage" size="md" :total-rows="total" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>

        <loading :loading="loading"></loading>

      </div>
    </div>

  </div>
</template>


<script>
import ClientsTable from '../components/tables/ClientsTable'

export default {
  components: {
    ClientsTable,
  },
  created() {
    const clients = this.$store.getters.getClients(this.currentPage)

    if (!clients.length) {
      this.loadClients(this.currentPage)
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      itemsPerPage: 20,
    }
  },
  computed: {
    clients() {
      return this.$store.getters.getClients(this.currentPage)
    },
    total() {
      return this.$store.getters.getClientsTotal
    },
  },
  methods: {
    loadClients(page) {
      this.loading = true
      this.$store.dispatch('getClients', {page, itemsPerPage: this.itemsPerPage})
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    currentPage() {
      this.loadClients(this.currentPage)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/ClientsPage.vue